export default function PendingApproval() {
  return (
    <div className="max-w-lg mx-auto mt-20 text-center">
      <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-8">
        <div className="text-4xl mb-4">&#x23F3;</div>
        <h2 className="text-xl font-bold text-yellow-800 mb-2">Account Pending Approval</h2>
        <p className="text-yellow-700 mb-4">
          Your account has been created but needs admin approval before you can access notes, recordings, and navigation features.
        </p>
        <p className="text-sm text-yellow-600">
          You can still browse the company directory and view exhibitor details while you wait.
        </p>
      </div>
    </div>
  )
}
